import { connect } from "react-redux";
import { getSetting } from "@focus/services/lib/settings/selectors";
export const _Setting = (props) => {
    const { setting } = props;
    return props.children({
        setting,
    });
};
const mapStateToProps = (state, { settingName }) => ({
    setting: getSetting(state.settings, settingName),
});
export const Setting = connect(mapStateToProps)(_Setting);
//# sourceMappingURL=Setting.js.map